export class GlobalUser {
  id: number;
  first_name: string;
  last_name: string;
  username: string;
  email: string;
  is_active: boolean;
  is_superuser: boolean;
  trial_user?: boolean;
  idle_time?: number;
  url_2?: string;
  url_3?: string;
  // groups?: [];
  groups: Groups[];
  date_joined: string;
  configs?: UserConfig;
  ceadmin: boolean;
  number_of_notifications?: number;
  organization?: Organiztion;
  new_configs?: UserConfig1;
}

export class Groups {
  id: number;
  name: string;
  permissions: [];
}

export class UserDashboardFiles {
  results: UserDashboard;
  total: number;
  url_token: string;
}

export class UserDashboard {
  keywords: [];
  files: UserFiles[];
  numbers: UserFileStats[];
}

export class UserFiles {
  filename: string;
  id: number;
  keyword_tags: [];
  last_saved: number;
  modified_time: string;
  original_filename: string;
  page_label_start: number;
  processed: boolean;
  status: string;
  thumbnail: string;
  total_pages: number;
  zoom_level: number;
}

export class UserFileStats {
  name: string;
  value: number;
}

export class UserConfig {
  auto_save: boolean;
  math_api: boolean;
  chem_api?: boolean;
  mathml?: boolean;
  latex?: boolean;
  state_diagram?: boolean;
  tag_form: boolean;
  docx_download: boolean;
  epub_download: boolean;
  html_download: boolean;
  enable_manage_accounts: boolean;
  rsp?: boolean;
  rsp_admin?: boolean;
  rsp_upload_text?: string;
  rsp_credit?: number;
  rsp_pay?: boolean;
  clms?: boolean;
  civic_plus?: boolean; // Added for CivicPlus
  API_tool?: boolean;
  upload_file?: boolean;
  delete_file?: boolean;
  d2l?: boolean;
  auto_tag?: boolean;
  gtxt_api?: boolean;
}

export class Organiztion {
  id: number;
  logo: string;
  name: string;
  org_type: string;
  enable_department_hierarchy: boolean;
}

export class UserConfig1 {
  organization?: Organiztion1l;
  api_configs?: Api_Config;
  prep_configs?: Prep_Config;
  file_access_configs?: FileAccessConifg;
  file_export_option?: FileExportOption;
  user_access_level_type?: string;
  rsp_service_enabled?: boolean;
  subscription_configs?: SubscriptionConfig;
  plan_type?: string; // use Code value
  license_expired?: boolean;
  users?: UserInfo;
  is_team_admin?: boolean;
  is_superadmin?: boolean;
  ceadmin?: boolean;
}

export class Organiztion1l {
  id?: number;
  logo?: string;
  name?: string;
  org_type?: string;
  enable_department_hierarchy?: boolean;
  idle_time?: number;
  url_2?: string;
  url_3?: string;
}

export class Api_Config {
  ocr?: boolean;
  multi_lang_ocr?: boolean;
  chem_inorganic?: boolean;
  special_no_line?: boolean;
  state_diagram?: boolean;
  gpt?: boolean;
  math_api?: boolean;
  mathml?: boolean;
  latex?: boolean;
}

export class Prep_Config {
  clms: boolean;
  civic_plus?: boolean; // Added for CivicPlus
  d2l: boolean;
  auto_tag: boolean;
  forms: boolean;
  redo_ocr_enabled?: boolean;
  load_tagged_pdf_enabled?: boolean;
  auto_save: boolean;
  showtemplate: boolean;
}

export class FileAccessConifg {
  can_view?: boolean;
  can_edit?: boolean;
  can_upload?: boolean;
  can_delete?: boolean;
}

export class FileExportOption {
  docx: boolean;
  epub: boolean;
  html: boolean;
}

export class UserInfo {
  first_name: string;
  last_name: string;
  username: string;
  email: string;
  is_active: boolean;
  id: boolean;
  created_date: string;
  is_superuser: boolean;
  trial_user: boolean;
  number_of_notifications: number;
  is_superadmin: boolean;
  idle_time: number;
  url_2: string;
  url_3: string;
  enable_manage_accounts?: boolean;
}

export class SubscriptionConfig {
  id?: number;
  organization_id?: number;
  subscription_type?: string; // yes Paid | no Trial        values: trial | paid
  plan_type?: string; // Id loaded from the get plan type sent by backend
  license_name?: string;
  number_of_licences?: number;
  license_start_date?: string;
  license_end_date?: string;

  // PREP Configuration
  auto_tag?: boolean;
  clms?: boolean;
  civic_plus?: boolean; // Added for CivicPlus
  forms?: boolean;
  d2l?: boolean;
  redo_ocr_enabled?: boolean;
  load_tagged_pdf_enabled?: boolean;

  // Template Configuration:
  show_template: boolean;

  // File Export Option  hide all is false show if any one is true
  docx: boolean;
  epub: boolean;
  html: boolean;

  // Concurrent Users
  concurrent_all: boolean; // No - All Users  & Yes - Limit
  concurrent_users: number; // Yes show

  // File Uploads
  cummilative_upload: boolean; // No - Unlimited & Yes - Limit
  total_pages: number; // Yes show
  total_files: number; // Yes show
  total_filesize_limit: number; // Yes show
  // Language
  document_language: []; // Static loading of all the language

  // Automated Alt Text Configuration    Question: Ask allowed users all vs limit should have a boolean  allow_all_users:
  enable_altext: boolean;
  allow_all_users: boolean;
  no_of_api_account: number; // No allow_all_users enable
  math: boolean; // READ
  math_api: boolean;
  math_limit: number; // Yes only show
  state_diagram: boolean;
  state_diagram_limit: number; // Yes only show
  chem_inorganic: boolean;
  chem_inorganic_limit: number; // Yes only show
  special_no_line: boolean;
  special_no_line_limit: number; // Yes only show
  gpt: boolean;
  gpt_limit: number; // Yes only show
  multi_lang_ocr: boolean;
  multi_lang_ocr_limit: number;

  // Question: We need the flag default OCR
  ocr: boolean;
  ocr_limit: number;

  // RSP Pricing configuration:
  // Remediation Cost Section:
  pricing_model_type: string; // Values:flat/document    flat- no    document -yes
  rsp_upload_text: string;
  simple_document: number; // Yes Document show
  complex_document: number; // Yes Document show
  rsp_per_page_price_config: number; // No flat price  show

  // Image ALt text Cost Section //
  pricing_model_type_image: string; // Values: flat/image      flat-no   image - yes
  simple_image: number; // Yes Image show
  complex_image: number; // Yes Image show
  image_price_config: number; // No flat price  show

  // rsp Credit configuration:
  is_rsp_credits_bought: boolean;
  rsp_allowed_credits: number; // Yes show this

  // file access:
  file_access_control: string; // Values:  organization/user   User - No   organization -Yes
  can_edit: boolean; // Yes show
  can_upload: boolean; // Yes show
  can_view: boolean; // Yes show
  can_delete: boolean; // Yes show

  // payment_configuration:

  payment_mode: string; // Values online/offline
  admin_upload_to_dept: boolean; // True - Admin can upload with department  False - Admin can upload without department
  show_pay_button: boolean; // True - is show pay button in the order
  requires_quote_approval: boolean; // True - Show approval or reject button in the order's quote section
  // accounting_details:
  subscription_status: string; // ID is loaded from get subscription status from backend
  payment_status: string; // ID is loaded from get payment status from backend
  total_cost: number;

  // CE Roles Access
  // ce_admin: boolean; // False  for Organization admin  True form CE amdin
  // enable_manage_accounts: boolean;
  ce_admin_can_create: boolean;
  comments: string;

  automation_type: string;
  lms_type: string;
  // Static Template Start
  is_enabled_static_template: boolean;
  static_template_purchase_type_check?: boolean;
  static_template_purchase_type: string;
  static_template_creation_right: boolean;
  static_template_setup_cost: number;
  static_templates_max_allowed: number;
  static_template_per_scan_cost: number;
  static_template_total_cost: number;

  static_template_scan_limit_type: string;
  static_template_scan_limit_type_check?: boolean;

  static_template_max_scans_allowed: number;
  static_template_enable_monthly_billing: boolean;

  // Static Template End

  // Dynamic Template Start
  dynamic_template_list: DynamicTemplate[];
  // Dynamic Template End
  enable_po: boolean; // Added for PO Number
  coupa_link: string;
}

export interface DynamicTemplate {
  dynamic_template_purchase_type_check: boolean;
  dynamic_template_purchase_type: string;
  template_deployed: boolean;
  dynamic_template_setup_cost: number | null;
  dynamic_template_per_scan_cost: number | null;
  dynamic_templates_total_count: number | null;
  dynamic_template_total_cost: number | null;
  dynamic_template_scan_limit_type_check: boolean;
  dynamic_template_scan_limit_type: string;
  dynamic_template_max_scans_allowed: number | null;
  dynamic_template_enable_monthly_billing: boolean;
  template_name: string;
  is_template_deployed: string;
  template_id: number | null;
  is_template_active: boolean;
  ce_template_code: string | null;
}
